import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardNavbarLinkElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { NavbarLink } from "@easy-email-pro-core/components";
import { NavbarLink as SourceElement } from "../../basic/NavbarLink";

const defaultData: ElementDefinition<StandardNavbarLinkElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {},
    data: {},
  });

export const StandardNavbarLink = createBlock<StandardNavbarLinkElement>({
  get name() {
    return t("Navbar Link");
  },
  defaultData,
  type: ElementType.STANDARD_NAVBAR_LINK,
  create: (payload) => {
    const defaultData: StandardNavbarLinkElement = {
      type: ElementType.STANDARD_NAVBAR_LINK,
      data: {
        content: "",
      },
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.NAVBAR_LINK,
  render(params) {
    const { node } = params;
    return (
      <NavbarLink idx={params.idx} {...node.attributes} data={node.data}>
        {params.children || node.children}
      </NavbarLink>
    );
  },
});
